import { Injector } from "@angular/core";
import { SimpleSearchListNode } from "../../SimpleSearchListNode"
import { MAHsEntityListView } from "../../../Data/MedicinalProductData/MAHsEntityListView";
import { EntityEnum } from "../../EntityEnum";
import { MAHAutoUploadEntity } from "../Entity/MAHAutoUploadEntity";
import { BaseNode } from "../../BaseNode";


export class TreeNodeMedicinalProductsMAH extends SimpleSearchListNode {
    useHist: boolean = false;
    constructor(injector: Injector, items: any[]|undefined, useHist: boolean) {
        super(injector, new MAHsEntityListView(items), 'MAHs', EntityEnum.mah);
        this.useHist = useHist;
    }


    override addChild(model: any): BaseNode|undefined {
        const labelTemplate = `${model.ev_Code} - ${model.name_Org}`;
        return this.addChildNode(MAHAutoUploadEntity,labelTemplate, this,model,this.useHist, false,false);
    }

    override getCriteriaFields(): string[] {
        return ['ev_Code','name_Org'];
    }

    override getPlaceHolderTemplate(): string {
        return "Search for MAHs available in the XEVMPD [visibility restrictions may apply] including those owned by your HQ";
    }
}